export default {"src":"/_next/static/media/granditude_logo_light.1db4efb1.svg","height":31,"width":150,"blurWidth":0,"blurHeight":0};